'use strict';

import { ConfigurationRequest } from './ConfigurationRequest';
import { DomainContext } from '../../../../parametrage/DomainContext';

class HelpRequest extends ConfigurationRequest {
    constructor(domain: DomainContext, _id? : string){
        super('help', domain, _id);
    }
}

export { HelpRequest };